import React, { useState, useEffect } from "react";
import "./MedicalForm.css";
import medicalFormData from "./medicalFormData";
import BackBtn from "../../Components/BackBtn/BackBtn";
import CourseFormModal from "../../Components/CourseFormModal/CourseFormModal";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Alert from "../../Components/Alert/Alert";
import { useBaseUrl } from "../../ApiContext";

export default function MedicalForm() {
  const questionsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl()
  const navigate = useNavigate();
  const location = useLocation();
  const { formId, planType } = location.state || {};
  const [currentQuestions, setCurrentQuestions] = useState([]);
  const [checkboxState, setCheckboxState] = useState({});
  const [showModal, setShowModal] = useState(false);
  const medicalFormAnswersInit = medicalFormData.reduce((acc, item) => {
    acc[item.label] = { description: "", has_illness: false };
    return acc;
  }, {});
  const [medicalFormAnswers, setMedicalFormAnswers] = useState(
    medicalFormAnswersInit
  );
  const [showAlert, setShowAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  useEffect(() => {
    const startIndex = (currentPage - 1) * questionsPerPage;
    const endIndex = startIndex + questionsPerPage;
    setCurrentQuestions(medicalFormData.slice(startIndex, endIndex));
  }, [currentPage]);

  const handleNext = async () => {
    if (currentPage * questionsPerPage < medicalFormData.length) {
      setCurrentPage((prevState) => prevState + 1);
    } else {
      try {
        const response = await Axios.post(
          `${baseUrl}/${planType}_plan/${formId}/medical_history`,
          medicalFormAnswers,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        if (response.status === 200) {
          navigate("/uploadImage", { state: { id: formId, planType: planType } });
        }
      } catch (error) {
        console.log("Error during sending medical data", error);
        setShowErrorAlert(true);
        setTimeout(() => {
          setShowErrorAlert(false);
        }, 2000);
      }
    }
  };

  const handleCheckboxChange = (questionId, questionLabel, option) => {
    setCheckboxState((prevCheckboxState) => ({
      ...prevCheckboxState,
      [`${questionId}_yes`]: option === "yes",
      [`${questionId}_no`]: option === "no",
    }));

    setMedicalFormAnswers((prevMedicalFormAnswers) => ({
      ...prevMedicalFormAnswers,
      [questionLabel]: {
        description: "",
        has_illness: option === "yes",
      },
    }));

    if (option === "yes") {
      setShowModal(true);
    }
  };

  const hideModal = () => {
    setShowModal(false);
  };

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">
            ارزیابی پزشکی{" "}
            <img
              src="/images/report.svg"
              alt="report icon"
              className="reportIcon"
            />
          </div>
          <div className="medicalForm centeredFlex scroll">
            {currentQuestions.map((question) => (
              <div key={question.id} className="medicalFormItem centeredFlex">
                <span className="medicalFormQuestion">{question.title}</span>
                <div className="medicalFormAnswers centeredFlex">
                  <label className="medicalFormAnswer medicalFormNo">
                    <input
                      type="checkbox"
                      className="radioBtn"
                      checked={checkboxState[`${question.id}_no`] || false}
                      onChange={() =>
                        handleCheckboxChange(question.id, question.label, "no")
                      }
                    />
                    <span className="customRadioBtn medicalCustomRadioBtn"></span>
                    <span>خیر</span>
                  </label>
                  <label className="medicalFormAnswer medicalFormYes">
                    <input
                      type="checkbox"
                      className="radioBtn"
                      checked={checkboxState[`${question.id}_yes`] || false}
                      onChange={() =>
                        handleCheckboxChange(question.id, question.label, "yes")
                      }
                    />
                    <span className="customRadioBtn medicalCustomRadioBtn"></span>
                    <span>بله</span>
                  </label>
                </div>
              </div>
            ))}
            <div className="medicalFormBtnWrapper">
              <button className="nextQuestion" onClick={handleNext}>
                بعدی
              </button>
            </div>
          </div>
          <CourseFormModal
            show={showModal}
            onHandleHide={hideModal}
            btnText="تایید"
            body="لطفا پس از تکمیل فرم ها، بیماری خود را از طریق پشتیبانی حتما با مربی در میان بگذارید"
          />
          <Alert showAlert={showAlert} alertText="در حال ارسال اطلاعات" />
          <Alert showAlert={showErrorAlert} alertText="خطا در برقراری ارتباط" />
        </div>
      </div>
    </div>
  );
}
